const preventDefault = {
    items: '',


    init(items = false) {

        this.items = items;
        this.prevent();

    },

    prevent() {

        this.items.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
            });

        });

    },

}

export default preventDefault;